export const getFlashMessage = state => state.flashMessage;
export const getFlashMessages = state => state.flashMessage.flashMessages;
export const getDisplayHeaderFlashMessage = state => state.flashMessage.displayHeaderFlashMessage;
export const getHeaderFlashMessage = state => state.flashMessage.headerFlashMessage;
export const getErrors = state => state.flashMessage.errors;
